import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    NotificationHeader,
    NotificationHeaderArrowIcon,
    NotificationHeaderName,
    NotificationsMenuWrapper,
} from './NotificationsMenu.style';
import { NotificationsMenuBets } from 'src/components/Header/LHSMenu/NotificationsMenu/NotificationsMenuLists/Bets/NotificationsBetsList';
import { NotificationsMenuChat } from 'src/components/Header/LHSMenu/NotificationsMenu/NotificationsMenuLists/Chat/NotificationsChatList';
import { useCommon } from 'src/AppState/Common';
import { NotificationsCentreState } from 'src/components/NotificationsCentre/NotificationsCentreState';
import { useHandleNotifications } from 'src/components/NotificationsCentre/NotificationsCentre';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';

interface NotificationHeaderType {
    name: string;
    icon: JSX.Element;
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
    isOpen: boolean;
}

export const NotificationHeaderWrapper = observer(
    'NotificationHeaderWrapper',
    ({ name, icon, onClick, isOpen }: NotificationHeaderType): JSX.Element | null => {
        return (
            <NotificationHeader
                onClick={onClick}
                className='text-foreground'
            >
                {icon}
                <NotificationHeaderName>{name}</NotificationHeaderName>
                <NotificationHeaderArrowIcon isOpen={isOpen} />
            </NotificationHeader>
        );
    }
);

interface NotificationMenuType {
    isOpen: boolean;
}

export const NotificationMenu = observer('NotificationMenu', ({ isOpen }: NotificationMenuType): JSX.Element | null => {
    const common = useCommon();
    const state = NotificationsCentreState.get(common);
    const { notificationSounds } = ConfigState.get(common).config;

    useHandleNotifications(state, notificationSounds);

    return (
        <NotificationsMenuWrapper isOpen={isOpen}>
            {isOpen ? (
                <>
                    <NotificationsMenuBets />

                    <NotificationsMenuChat />
                </>
            ) : null}
        </NotificationsMenuWrapper>
    );
});
